import { render, staticRenderFns } from "./k-tag.vue?vue&type=template&id=37472638&scoped=true&"
import script from "./k-tag.vue?vue&type=script&lang=js&"
export * from "./k-tag.vue?vue&type=script&lang=js&"
import style0 from "./k-tag.vue?vue&type=style&index=0&id=37472638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37472638",
  null
  
)

export default component.exports